import axiosInstance from '../api';

export const createQuoteService = async body =>
  await axiosInstance.post('osa/quote', JSON.stringify(body));
